export class TagInformation {

  sequence!: number;
  tag!: string;
  poLine!: string;
  riser!: string;
  floor!: string;
  room!: string;
  building!: string;

}
